module.exports = __webpack_public_path__ + "icon_kulttuuri.ab4151a579196aa0f004.svg";